module.exports = {
  purple1: "#855279",
  purple2: "#B575BB",
  purple3: "#DABADD",
  yellow1: "#AC8E4C",
  yellow2: "#FFD373",
  yellow3: "#F0DFBC",
  peach1: "#AE6E52",
  peach2: "#F79C75",
  peach3: "#F1CEBF",
  blue1: "#1B6383",
  blue2: "#268CBA",
  blue3: "#A1C8DA",
  teal1: "#178287",
  teal2: "#19A4AB",
  teal3: "#9CD1D4",
  teal4: "#D1EDEE",
  gray1: "#393939",
  gray2: "#828282",
  gray3: "#DCDCDC",
  gray4: "#ECECEC"
};
